import { useEffect, useState } from 'react';
import { remainingMs, supportTime, type SupportTime } from './supportTime';

const timeAt = (expiresAt: string) => supportTime(remainingMs(expiresAt, Date.now()));

/**
 * Restzeit aus dem Ablauf des Servers. Die Anzeige rechnet nur; zurück in die Heimatsitzung führt
 * die Sitzung selbst, sobald sie abläuft.
 */
export function useSupportCountdown(expiresAt: string): SupportTime {
  const [time, setTime] = useState(() => timeAt(expiresAt));
  useEffect(() => {
    setTime(timeAt(expiresAt));
    const timer = window.setInterval(() => {
      const next = timeAt(expiresAt);
      setTime((current) =>
        current.text === next.text && current.warning === next.warning ? current : next,
      );
    }, 1_000);
    return () => window.clearInterval(timer);
  }, [expiresAt]);
  return time;
}
